import React, { useState } from 'react';
import { IUserJson } from '@scale/shared/types/user';
import { Typography } from '@scale/scaleui';
import TaskerScreeningAuditPermissionRoleCreationTool from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningAuditPermissionRoleCreationTool';
import TaskerScreeningAuditorPermissionsTool from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningAuditorPermissionsTool';

interface TaskerScreeningAuditorPermissionsProps {
  user: IUserJson;
}

const TaskerScreeningAuditorPermissions: React.FC<TaskerScreeningAuditorPermissionsProps> = ({
  user,
}) => {
  const [needsFetch, setNeedsFetch] = useState(true);

  return (
    <div className="scaleui scale-theme scale-tailwind p-4">
      <div className="mb-8">
        <Typography.H4>Create Permission Roles</Typography.H4>
        <p>
          Create permission roles for screening courses and sections that auditors will be assigned
          to.
        </p>
        <TaskerScreeningAuditPermissionRoleCreationTool user={user} setNeedsFetch={setNeedsFetch} />
      </div>
      <div className="mb-8">
        <Typography.H4>Review Roles and Assign Workers</Typography.H4>
        <p className="mb-4">
          Review permission roles that workers can be assigned to. Use this tool to assign workers
          to permission roles.
        </p>
        <TaskerScreeningAuditorPermissionsTool
          user={user}
          needsFetch={needsFetch}
          setNeedsFetch={setNeedsFetch}
        />
      </div>
    </div>
  );
};

export default TaskerScreeningAuditorPermissions;
